<style scoped lang="scss">
.page {
    min-height: 100vh;
    background: linear-gradient(180deg, #f8fafc 0%, #eef2ff 60%, #f8fafc 100%);
    display: flex;
    flex-direction: column;
}

.page-main {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20vh 1.5rem 4rem;
    position: relative;
    max-height: 90vh;
    overflow-y: auto;
}
.page-main::-webkit-scrollbar {
    width: 0;
    height: 0;
    display: none;
}
.page-main::before {
    content: '';
    position: absolute;
    inset: 0;
    background:
        radial-gradient(circle at 15% 20%, rgba(59, 130, 246, 0.15), transparent 40%),
        radial-gradient(circle at 85% 10%, rgba(99, 102, 241, 0.15), transparent 45%);
    pointer-events: none;
}

.card {
    position: relative;
    width: min(900px, 94vw);
    background: #ffffff;
    border-radius: 1.4rem;
    border: 1px solid rgba(226, 232, 240, 0.9);
    box-shadow: 0 22px 45px -30px rgba(15, 23, 42, 0.4);
    padding: 2.4rem 2.6rem;
    z-index: 1;
    transition: box-shadow 0.25s ease, transform 0.25s ease;
}

.card:hover {
    transform: translateY(-2px);
    box-shadow: 0 28px 50px -32px rgba(15, 23, 42, 0.45);
}

.card-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1.5rem;
    margin-bottom: 1.5rem;
}

.title-group {
    display: flex;
    flex-direction: column;
    gap: 0.4rem;
}

.title {
    font-size: 1.6rem;
    font-weight: 700;
    color: #0f172a;
}

.subtitle {
    font-size: 0.95rem;
    color: #64748b;
}

.header-chip {
    display: inline-flex;
    align-items: center;
    gap: 0.4rem;
    padding: 0.35rem 0.85rem;
    border-radius: 9999px;
    font-size: 0.8rem;
    font-weight: 600;
    background: rgba(37, 99, 235, 0.12);
    color: #1e40af;
    border: 1px solid rgba(37, 99, 235, 0.2);
    white-space: nowrap;
    box-shadow: 0 8px 18px -16px rgba(37, 99, 235, 0.55);
}

.content-grid {
    display: grid;
    grid-template-columns: minmax(0, 1.1fr) minmax(0, 0.9fr);
    gap: 2rem;
}

.form-card {
    padding: 1.5rem;
    border-radius: 1rem;
    border: 1px solid rgba(226, 232, 240, 0.85);
    background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
    box-shadow: 0 16px 28px -24px rgba(15, 23, 42, 0.3);
    transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.form-card:hover {
    border-color: rgba(37, 99, 235, 0.35);
    box-shadow: 0 18px 30px -24px rgba(37, 99, 235, 0.28);
}

.info-card {
    padding: 1.5rem;
    border-radius: 1rem;
    border: 1px solid rgba(226, 232, 240, 0.85);
    background: #f8fafc;
    box-shadow: 0 16px 28px -24px rgba(15, 23, 42, 0.3);
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.info-card:hover {
    border-color: rgba(99, 102, 241, 0.35);
    box-shadow: 0 18px 30px -24px rgba(99, 102, 241, 0.28);
}

.info-block {
    display: grid;
    gap: 0.6rem;
}

.info-title {
    font-weight: 600;
    color: #0f172a;
}

.info-list {
    display: grid;
    gap: 0.5rem;
    color: #475569;
    font-size: 0.95rem;
}

.info-list span {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    background: rgba(255, 255, 255, 0.75);
    border: 1px solid rgba(226, 232, 240, 0.9);
    padding: 0.35rem 0.6rem;
    border-radius: 0.65rem;
}

.info-dot {
    width: 0.45rem;
    height: 0.45rem;
    border-radius: 9999px;
    background: rgba(37, 99, 235, 0.5);
}

.includes-decription {
    width: 100%;
    border-radius: 0.95rem;
    border: 1px solid rgba(226, 232, 240, 0.9);
    overflow: hidden;
    background: #ffffff;
}

:deep(.el-card__header) {
    background: #f8fafc;
    padding: 1rem 1.1rem;
    border-bottom: 1px solid rgba(226, 232, 240, 0.8);
}

:deep(.el-card__header .card-header) {
    font-weight: 600;
    color: #0f172a;
    font-size: 0.98rem;
}

:deep(.el-card__body) {
    padding: 1rem 1.1rem 1.2rem;
    color: #475569;
    font-size: 0.95rem;
    line-height: 1.6;

    strong {
        color: #2563eb;
        font-weight: 600;
    }
}

.action-area {
    display: flex;
    flex-direction: column;
    gap: 0.9rem;
}

.submit-btn {
    width: 100%;
    height: 2.9rem;
    font-size: 0.96rem;
    font-weight: 600;
    border-radius: 0.85rem;
    background: linear-gradient(135deg, #2563eb, #3b82f6);
    border: none;
    color: #ffffff;
    transition: all 0.2s ease;

    &:hover {
        transform: translateY(-1px);
        box-shadow: 0 12px 22px -18px rgba(37, 99, 235, 0.55);
    }
}

.tips {
    font-size: 0.85rem;
    color: #64748b;
    background: #ffffff;
    border-radius: 0.75rem;
    border: 1px dashed rgba(148, 163, 184, 0.5);
    padding: 0.85rem 1rem;
    line-height: 1.6;
}

::deep(.el-form-item) {
    margin-bottom: 1.2rem;
}

::deep(.el-form-item__label) {
    font-weight: 600;
    color: #334155;
    font-size: 0.92rem;
    margin-bottom: 0.35rem;
}

::deep(.el-input__wrapper),
::deep(.el-select__wrapper) {
    border-radius: 0.75rem;
    padding: 0 0.9rem;
    box-shadow: 0 0 0 1px rgba(148, 163, 184, 0.35);
    transition: all 0.2s ease;
    background: #ffffff;
    height: 2.8rem;
    align-items: center;
}

::deep(.el-input__wrapper:hover),
::deep(.el-select__wrapper:hover) {
    box-shadow: 0 0 0 1px rgba(37, 99, 235, 0.35);
}

::deep(.el-input__wrapper.is-focus),
::deep(.el-select__wrapper.is-focus),
::deep(.el-input__wrapper:focus-within),
::deep(.el-select__wrapper:focus-within) {
    box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.35);
}

::deep(.el-input__inner) {
    height: 2.8rem;
    font-size: 0.95rem;
    color: #0f172a;
}

::deep(.el-select) {
    width: 100%;
}

@media screen and (max-width: 1024px) {
    .content-grid {
        grid-template-columns: 1fr;
    }

    .card {
        padding: 2rem;
    }
}

@media screen and (max-width: 640px) {
    .page-main {
        padding: 2.5rem 1rem 3rem;
    }

    .card-header {
        flex-direction: column;
        align-items: flex-start;
    }
}
</style>
<template>
    <div class="page" :style="bgStyle">
        <IndexHeader />
        <main class="page-main">
            <section class="card">
                <div class="card-header">
                    <div class="title-group">
                        <div class="title">免费授权</div>
                        <div class="subtitle">填写插件、版本与授权信息，快速领取免费授权。</div>
                    </div>
                    <span class="header-chip">
                        <i class="el-icon-circle-check"></i>
                        秒级开通
                    </span>
                </div>

                <div class="content-grid">
                    <div class="form-card">
                        <el-form :label-position="form_position" label-width="90px" :model="form">
                            <el-form-item label="插件">
                                <el-select v-model="form.includes_id" placeholder="请选择插件" @change="selectIncludes">
                                    <el-option v-for="item in includes_data" :key="item.id"
                                        :label="item.id + '---' + item.name" :value="item.id"></el-option>
                                </el-select>
                            </el-form-item>

                            <el-form-item label="功能版本" v-if="form.includes_id">
                                <el-select v-model="form.version" placeholder="请选择功能版本" @change="selectVersion"
                                    :disabled="version_list.length === 0">
                                    <el-option v-for="item in version_list" :key="item.version"
                                        :label="item.versionName" :value="item.version"></el-option>
                                    <el-option v-if="version_list.length === 0 && form.includes_id" disabled>
                                        --该插件无版本信息--
                                    </el-option>
                                </el-select>
                            </el-form-item>

                            <el-form-item label="授权字段">
                                <el-input v-model="form.host" name="host" placeholder="如：example.com"></el-input>
                            </el-form-item>
                            <el-form-item label="绑定邮箱">
                                <el-input v-model="form.email" name="host" placeholder="用于找回与通知"></el-input>
                            </el-form-item>
                            <el-form-item label="推荐人uid">
                                <el-input v-model="form.uid" name="host" placeholder="选填，填推荐人uid"></el-input>
                            </el-form-item>
                        </el-form>
                    </div>

                    <div class="info-card">
                        <div class="info-block">
                            <div class="info-title">授权说明</div>
                            <el-card class="box-card includes-decription">
                                <template #header>
                                    <div class="card-header">
                                        <span>授权规则</span>
                                    </div>
                                </template>
                                <div v-if="select_Includes.isWhole == 1">
                                    请填写机器码授权，不知道机器码是什么？先安装易售软件，登录后台会弹出机器码。
                                    <span v-if="selected_version.free_day">
                                        免费时长<strong>{{ selected_version.free_day }}</strong>天
                                    </span>
                                    <span v-else-if="select_Includes.freeDay">
                                        免费时长<strong>{{ select_Includes.freeDay }}</strong>天
                                    </span>
                                </div>
                                <div v-else-if="select_Includes.isWhole == 0">
                                   请填写机器码授权，不知道机器码是什么？先安装易售软件，登录后台会弹出机器码。
                                    <span v-if="selected_version.free_day">
                                        免费时长<strong>{{ selected_version.free_day }}</strong>天
                                    </span>
                                </div>
                                <div v-else>请选择软件</div>
                            </el-card>
                        </div>

                        <div class="info-block">
                            <div class="info-title">授权提示</div>
                            <div class="info-list">
                                <span><i class="info-dot"></i> 授权字段就是你的机器码，需真实有效</span>
                                <span><i class="info-dot"></i> 绑定邮箱用于找回与通知</span>
                                <span><i class="info-dot"></i> 填写推荐人uid可记录推广关系</span>
                            </div>
                        </div>

                        <div class="action-area">
                            <el-button type="success" class="submit-btn" @click="addAuth()">免费授权</el-button>
                            <div class="tips">
                                提交后系统将自动生成免费授权信息，请耐心等待提示。
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </main>
        <IndexFooter />
    </div>
</template>
<script>
import { defineComponent } from 'vue';
import axios from 'axios';
import { ElMessage } from 'element-plus'
import { openLoading, fullscreenLoading } from '@/utils/loadingUtils'
import IndexHeader from '@/components/IndexHeader.vue'
import IndexFooter from '@/components/IndexFooter.vue'
const baseURL = process.env.VUE_APP_API_BASE_URL;
export default defineComponent({
    components: {
        IndexHeader,
        IndexFooter
    },
    data() {
        return {
            form: {
                host: "",
                includes_id: "",
                eamil: "",
                uid: "",
                version: "" // Add version field
            },
            includes_data: [],
            select_Includes: {},
            selected_version: {}, // Add selected version data
            version_list: [], // Add version list
            form_position: "top",
            bgImageUrl: [
                require('@/assets/img/bg2.webp'),
                require('@/assets/img/bg3.jpg'),
                require('@/assets/img/bg4.png'),
                require('@/assets/img/bg5.png'),
                require('@/assets/img/bg6.webp'),
                require('@/assets/img/bg7.webp'),
                require('@/assets/img/bg8.webp'),
                require('@/assets/img/bg9.webp'),
            ]
        }
    },
    computed: {
        bgStyle() {
            let i = Math.floor(Math.random() * this.bgImageUrl.length);
            return {
                // 'background': `url(${this.bgImageUrl[i]})`
            };
        }
    },
    methods: {
        addAuth() {
            openLoading()
            const headers = {
                'token': localStorage.getItem("token"),
                'content-type': 'application/json'
            }
            axios.post(baseURL + '/free/addAuth', JSON.stringify(this.form), { timeout: 30000, headers })
                .then(res => {
                    if (res.data.code == 200) {
                        ElMessage.success(res.data.msg)
                    } else {
                        ElMessage.error(res.data.msg)
                    }
                }).catch(err => {
                    this.$message.error(err);
                }).finally(() => {
                    fullscreenLoading.close()
                })

        },
        selectIncludes(id) {
            for (let i = 0; i < this.includes_data.length; i++) {
                const element = this.includes_data[i];
                if (element.id == id) {
                    this.select_Includes = element;
                    break; // Add break for efficiency
                }
            }

            // Reset version selection when plugin changes
            this.form.version = "";
            this.version_list = [];
            this.selected_version = {};

            // Fetch versions for the selected plugin
            if (id) {
                this.getPluginVersions(id);
            }
        },
        getPluginVersions(soft_id) {
            openLoading();
            const headers = {
                'content-type': 'application/json'
            };

            const data = {
                soft_id: soft_id
            };

            axios.post(baseURL + "/userApi/getSoftVersion", data, { timeout: 30000, headers })
                .then(res => {
                    fullscreenLoading.close();
                    if (res.data.code == 200) {
                        this.version_list = res.data.data.list || [];
                        // Auto-select if only one version
                        if (this.version_list.length === 1) {
                            this.form.version = this.version_list[0].version;
                            this.selectVersion(this.version_list[0].version);
                        }
                    } else {
                        ElMessage.error(res.data.msg || '获取版本信息失败');
                    }
                })
                .catch(err => {
                    fullscreenLoading.close();
                    console.log(err);
                    ElMessage.error('获取版本信息失败：' + err.message);
                });
        },
        selectVersion(version) {
            // Find the selected version in the list
            this.selected_version = this.version_list.find(item => item.version === version) || {};
        },
        getIncludes() {
            axios.get(baseURL + '/free/getFreeIncludes', { timeout: 30000 }).then(
                res => {
                    if (res.data.code == 200) {
                        this.includes_data = res.data.data
                    } else {
                        ElMessage.error(res.data.msg)
                    }
                }, err => {
                    ElMessage.error(err)
                }
            )
        },
        setFormPosition() {
            window.innerWidth < 768 ? this.form_position = "top" : this.form_position = "left"
        }
    },
    mounted() {
        this.getIncludes()
        this.setFormPosition()
    }
})
</script>

